export default __webpack_public_path__ + "static/media/p-1.feedb01b.png";